import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { MODAL_HIDE } from '../../../constants/action-types';

class UserPromptModalComponent extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (<div>
            <h1>Become an oracle</h1>
            <form>
                <input type='text' name='email' placeholder='Your email...' />
            </form>
            <button className='primary' onClick={this.props.hide.bind(this)}>No</button>
            <button className='primary' onClick={this.props.oracleCollectEmails.bind(this)}>Yes</button>
        </div>)
    }
}

const mapStateToProps = (state) => state

const mapDispatchToProps = (dispatch) => ({
    hide: () => dispatch({type: MODAL_HIDE}),
    oracleCollectEmails: (email) => dispatch({ type: ORACLE_COLLECT_EMAILS, payload: email })
});


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserPromptModalComponent)


// WEBPACK FOOTER //
// ./src/components/templates/modals/oracle-collect-emails.js